/**
 * Vista: Formulario de Registro de Compra Final
 *
 * Permite registrar una compra con:
 * - Desglose completo de costos
 * - Múltiples tractores
 * - Documentación aduanal
 */

import router from '../router/router.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header">
          <h2 class="card-title">📦 Registrar Compra Final</h2>
        </div>

        <form id="compraForm" style="display: grid; gap: 2rem;">
          <!-- Sección 1: Información de la Orden de Compra -->
          <div class="form-section">
            <h3 class="section-title">1. Orden de Compra</h3>

            <div class="form-grid">
              <div class="form-group">
                <label class="form-label required">Orden de Compra</label>
                <select id="ordenCompraId" class="form-select" required>
                  <option value="">Seleccione una OC...</option>
                </select>
                <small class="form-hint">Solo órdenes confirmadas</small>
              </div>

              <div id="ocInfo" style="grid-column: 1 / -1; display: none;">
                <div class="info-box">
                  <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem;">
                    <div>
                      <strong>Proveedor:</strong>
                      <div id="ocProveedor">-</div>
                    </div>
                    <div>
                      <strong>Total OC:</strong>
                      <div id="ocTotal">-</div>
                    </div>
                    <div>
                      <strong>Fecha OC:</strong>
                      <div id="ocFecha">-</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sección 2: Información de la Compra -->
          <div class="form-section">
            <h3 class="section-title">2. Información de la Compra</h3>

            <div class="form-grid">
              <div class="form-group">
                <label class="form-label required">Fecha de Compra</label>
                <input type="date" id="fechaCompra" class="form-input" required />
              </div>

              <div class="form-group">
                <label class="form-label required">Fecha de Entrega</label>
                <input type="date" id="fechaEntrega" class="form-input" required />
              </div>

              <div class="form-group">
                <label class="form-label">Moneda</label>
                <select id="moneda" class="form-select">
                  <option value="USD">USD - Dólar Americano</option>
                  <option value="MXN">MXN - Peso Mexicano</option>
                </select>
              </div>

              <div class="form-group">
                <label class="form-label">Tipo de Cambio</label>
                <input
                  type="number"
                  id="tipoCambio"
                  class="form-input"
                  value="1.0000"
                  step="0.0001"
                  min="0"
                />
                <small class="form-hint">Dejar en 1 si es USD</small>
              </div>
            </div>
          </div>

          <!-- Sección 3: Desglose de Costos -->
          <div class="form-section">
            <h3 class="section-title">3. Desglose de Costos (en moneda seleccionada)</h3>

            <div class="form-grid">
              <div class="form-group">
                <label class="form-label required">Costo Base</label>
                <input
                  type="number"
                  id="costoBase"
                  class="form-input"
                  step="0.01"
                  min="0"
                  required
                />
                <small class="form-hint">Costo del tractor del proveedor</small>
              </div>

              <div class="form-group">
                <label class="form-label">Accesorios</label>
                <input
                  type="number"
                  id="costoAccesorios"
                  class="form-input"
                  step="0.01"
                  min="0"
                  value="0"
                />
                <small class="form-hint">Cabina, extras, equipamiento</small>
              </div>

              <div class="form-group">
                <label class="form-label">Impuestos</label>
                <input
                  type="number"
                  id="costoImpuestos"
                  class="form-input"
                  step="0.01"
                  min="0"
                  value="0"
                />
                <small class="form-hint">Arancel 25%, IVA, otros</small>
              </div>

              <div class="form-group">
                <label class="form-label">Gastos</label>
                <input
                  type="number"
                  id="costoGastos"
                  class="form-input"
                  step="0.01"
                  min="0"
                  value="0"
                />
                <small class="form-hint">Agente aduanal, permisos</small>
              </div>

              <div class="form-group">
                <label class="form-label">Flete</label>
                <input
                  type="number"
                  id="costoFlete"
                  class="form-input"
                  step="0.01"
                  min="0"
                  value="0"
                />
                <small class="form-hint">Flete internacional</small>
              </div>

              <div class="form-group">
                <label class="form-label" style="font-size: 1.1rem; font-weight: bold;">Total</label>
                <div id="totalCompra" class="form-input" style="font-size: 1.3rem; font-weight: bold; background: #f0f0f0;">
                  $0.00
                </div>
              </div>
            </div>
          </div>

          <!-- Sección 4: Documentación -->
          <div class="form-section">
            <h3 class="section-title">4. Documentación</h3>

            <div class="form-grid">
              <div class="form-group">
                <label class="form-label required">Número de Factura</label>
                <input
                  type="text"
                  id="numeroFactura"
                  class="form-input"
                  placeholder="INV-2025-001"
                  maxlength="50"
                  required
                />
              </div>

              <div class="form-group">
                <label class="form-label">Pedimento</label>
                <input
                  type="text"
                  id="pedimento"
                  class="form-input"
                  placeholder="25-12-3456-7890123"
                  maxlength="50"
                />
              </div>

              <div class="form-group">
                <label class="form-label">Agente Aduanal</label>
                <select id="agenteAduanalId" class="form-select">
                  <option value="">Ninguno</option>
                </select>
              </div>

              <div class="form-group" style="grid-column: 1 / -1;">
                <label class="form-label">Observaciones</label>
                <textarea
                  id="observaciones"
                  class="form-textarea"
                  rows="3"
                  maxlength="1000"
                  placeholder="Información adicional sobre la compra..."
                ></textarea>
              </div>
            </div>
          </div>

          <!-- Sección 5: Tractores -->
          <div class="form-section">
            <h3 class="section-title">
              5. Tractores Comprados
              <button type="button" class="btn btn-sm btn-primary" onclick="window.compraFormView.agregarTractor()">
                ➕ Agregar Tractor
              </button>
            </h3>

            <div id="tractoresContainer">
              <!-- Tractores agregados dinámicamente -->
            </div>
          </div>

          <!-- Botones -->
          <div class="form-actions">
            <button type="button" class="btn btn-secondary" onclick="router.navigate('/compras')">
              Cancelar
            </button>
            <button type="submit" class="btn btn-primary" id="submitBtn">
              💾 Registrar Compra
            </button>
          </div>
        </form>
      </div>
    `;
  },

  async afterRender() {
    window.compraFormView = this;

    this.tractores = [];
    this.ordenCompraSeleccionada = null;

    // Event listeners
    document.getElementById('ordenCompraId').addEventListener('change', (e) => {
      this.cargarInfoOC(e.target.value);
    });

    // Calcular total automáticamente
    ['costoBase', 'costoAccesorios', 'costoImpuestos', 'costoGastos', 'costoFlete'].forEach(id => {
      document.getElementById(id).addEventListener('input', () => {
        this.calcularTotal();
      });
    });

    document.getElementById('compraForm').addEventListener('submit', (e) => {
      e.preventDefault();
      this.guardarCompra();
    });

    // Cargar datos iniciales
    await this.cargarOrdenesCompra();
    await this.cargarAgentesAduanales();

    // Agregar primer tractor
    this.agregarTractor();
  },

  async cargarOrdenesCompra() {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/ordenes-compra?estado=confirmada&limite=100`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Error al cargar órdenes');

      const result = await response.json();
      const select = document.getElementById('ordenCompraId');

      result.data.ordenes.forEach(oc => {
        const option = document.createElement('option');
        option.value = oc.id;
        option.textContent = `${oc.folio} - ${oc.proveedor_nombre} - $${this.formatNumber(oc.total)} ${oc.moneda}`;
        option.dataset.oc = JSON.stringify(oc);
        select.appendChild(option);
      });
    } catch (error) {
      console.error('Error al cargar órdenes:', error);
      this.mostrarAlerta('Error al cargar órdenes de compra', 'error');
    }
  },

  async cargarAgentesAduanales() {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/personas/rol/agente_aduanal`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Error al cargar agentes');

      const result = await response.json();
      const select = document.getElementById('agenteAduanalId');

      result.data.personas.forEach(agente => {
        const option = document.createElement('option');
        option.value = agente.id;
        option.textContent = agente.nombre_comercial || agente.nombre_completo;
        select.appendChild(option);
      });
    } catch (error) {
      console.error('Error al cargar agentes:', error);
    }
  },

  cargarInfoOC(ocId) {
    if (!ocId) {
      document.getElementById('ocInfo').style.display = 'none';
      this.ordenCompraSeleccionada = null;
      return;
    }

    const select = document.getElementById('ordenCompraId');
    const option = select.options[select.selectedIndex];
    const oc = JSON.parse(option.dataset.oc);

    this.ordenCompraSeleccionada = oc;

    document.getElementById('ocProveedor').textContent = oc.proveedor_nombre;
    document.getElementById('ocTotal').textContent = `$${this.formatNumber(oc.total)} ${oc.moneda}`;
    document.getElementById('ocFecha').textContent = this.formatDate(oc.fecha_orden);
    document.getElementById('ocInfo').style.display = 'block';

    // Sugerir moneda de la OC
    document.getElementById('moneda').value = oc.moneda;
  },

  agregarTractor() {
    const index = this.tractores.length;
    this.tractores.push({});

    const container = document.getElementById('tractoresContainer');
    const tractorDiv = document.createElement('div');
    tractorDiv.className = 'tractor-item';
    tractorDiv.dataset.index = index;
    tractorDiv.innerHTML = `
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
        <h4 style="margin: 0;">Tractor #${index + 1}</h4>
        ${index > 0 ? `
          <button
            type="button"
            class="btn btn-sm btn-danger"
            onclick="window.compraFormView.eliminarTractor(${index})"
          >
            🗑️ Eliminar
          </button>
        ` : ''}
      </div>

      <div class="form-grid">
        <div class="form-group">
          <label class="form-label required">Marca</label>
          <input
            type="text"
            name="marca_${index}"
            class="form-input"
            maxlength="50"
            required
          />
        </div>

        <div class="form-group">
          <label class="form-label required">Modelo</label>
          <input
            type="text"
            name="modelo_${index}"
            class="form-input"
            maxlength="100"
            required
          />
        </div>

        <div class="form-group">
          <label class="form-label required">Año</label>
          <input
            type="number"
            name="anio_${index}"
            class="form-input"
            min="2000"
            max="${new Date().getFullYear() + 1}"
            required
          />
        </div>

        <div class="form-group">
          <label class="form-label required">Número de Serie</label>
          <input
            type="text"
            name="numeroSerie_${index}"
            class="form-input"
            maxlength="100"
            required
          />
        </div>

        <div class="form-group">
          <label class="form-label">Número de Motor</label>
          <input
            type="text"
            name="numeroMotor_${index}"
            class="form-input"
            maxlength="100"
          />
        </div>

        <div class="form-group">
          <label class="form-label">Color</label>
          <input
            type="text"
            name="color_${index}"
            class="form-input"
            maxlength="50"
          />
        </div>

        <div class="form-group">
          <label class="form-label">HP</label>
          <input
            type="number"
            name="hp_${index}"
            class="form-input"
            min="1"
          />
        </div>

        <div class="form-group">
          <label class="form-label required">Costo Unitario</label>
          <input
            type="number"
            name="costoUnitario_${index}"
            class="form-input"
            step="0.01"
            min="0"
            required
          />
        </div>

        <div class="form-group" style="grid-column: 1 / -1;">
          <label class="form-label">Observaciones</label>
          <textarea
            name="observacionesTractor_${index}"
            class="form-textarea"
            rows="2"
            maxlength="500"
          ></textarea>
        </div>
      </div>
    `;

    container.appendChild(tractorDiv);
  },

  eliminarTractor(index) {
    const container = document.getElementById('tractoresContainer');
    const tractorDiv = container.querySelector(`[data-index="${index}"]`);
    if (tractorDiv) {
      tractorDiv.remove();
      this.tractores[index] = null;
    }
  },

  calcularTotal() {
    const base = parseFloat(document.getElementById('costoBase').value) || 0;
    const accesorios = parseFloat(document.getElementById('costoAccesorios').value) || 0;
    const impuestos = parseFloat(document.getElementById('costoImpuestos').value) || 0;
    const gastos = parseFloat(document.getElementById('costoGastos').value) || 0;
    const flete = parseFloat(document.getElementById('costoFlete').value) || 0;

    const total = base + accesorios + impuestos + gastos + flete;

    document.getElementById('totalCompra').textContent = `$${this.formatNumber(total)}`;
  },

  async guardarCompra() {
    try {
      const submitBtn = document.getElementById('submitBtn');
      submitBtn.disabled = true;
      submitBtn.textContent = '⏳ Guardando...';

      // Obtener tractores
      const detalles = [];
      const form = document.getElementById('compraForm');

      this.tractores.forEach((_, index) => {
        if (this.tractores[index] !== null) {
          const marca = form.elements[`marca_${index}`]?.value;
          if (!marca) return; // Skip si no tiene marca (eliminado)

          detalles.push({
            marca: marca,
            modelo: form.elements[`modelo_${index}`].value,
            anio: parseInt(form.elements[`anio_${index}`].value),
            numero_serie: form.elements[`numeroSerie_${index}`].value,
            numero_motor: form.elements[`numeroMotor_${index}`].value || null,
            color: form.elements[`color_${index}`].value || null,
            hp: form.elements[`hp_${index}`].value ? parseInt(form.elements[`hp_${index}`].value) : null,
            costo_unitario: parseFloat(form.elements[`costoUnitario_${index}`].value),
            observaciones: form.elements[`observacionesTractor_${index}`].value || null
          });
        }
      });

      if (detalles.length === 0) {
        throw new Error('Debe agregar al menos un tractor');
      }

      // Preparar datos
      const data = {
        orden_compra_id: parseInt(document.getElementById('ordenCompraId').value),
        proveedor_id: this.ordenCompraSeleccionada.proveedor_id,
        fecha_compra: document.getElementById('fechaCompra').value,
        fecha_entrega: document.getElementById('fechaEntrega').value,
        moneda: document.getElementById('moneda').value,
        tipo_cambio: parseFloat(document.getElementById('tipoCambio').value),
        costo_base: parseFloat(document.getElementById('costoBase').value),
        costo_accesorios: parseFloat(document.getElementById('costoAccesorios').value),
        costo_impuestos: parseFloat(document.getElementById('costoImpuestos').value),
        costo_gastos: parseFloat(document.getElementById('costoGastos').value),
        costo_flete: parseFloat(document.getElementById('costoFlete').value),
        agente_aduanal_id: document.getElementById('agenteAduanalId').value || null,
        numero_factura: document.getElementById('numeroFactura').value,
        pedimento: document.getElementById('pedimento').value || null,
        observaciones: document.getElementById('observaciones').value || null,
        detalles: detalles
      };

      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/compras`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Error al registrar la compra');
      }

      this.mostrarAlerta('✅ Compra registrada exitosamente', 'success');

      setTimeout(() => {
        router.navigate(`/compras/${result.data.id}`);
      }, 1500);

    } catch (error) {
      console.error('Error al guardar compra:', error);
      this.mostrarAlerta(error.message, 'error');

      const submitBtn = document.getElementById('submitBtn');
      submitBtn.disabled = false;
      submitBtn.textContent = '💾 Registrar Compra';
    }
  },

  mostrarAlerta(mensaje, tipo = 'info') {
    const alertDiv = document.createElement('div');
    alertDiv.className = `alert alert-${tipo}`;
    alertDiv.textContent = mensaje;
    alertDiv.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 9999;
      padding: 1rem 1.5rem;
      border-radius: 4px;
      background: ${tipo === 'success' ? '#28a745' : tipo === 'error' ? '#dc3545' : '#007bff'};
      color: white;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    `;

    document.body.appendChild(alertDiv);

    setTimeout(() => {
      alertDiv.remove();
    }, 3000);
  },

  formatDate(dateString) {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-MX', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  },

  formatNumber(num) {
    if (!num) return '0.00';
    return parseFloat(num).toLocaleString('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
};
